import {useEffect, useRef} from 'react';
import {PaymentFormSkeleton} from './PaymentFormSkeleton';

type Props = {
  isLoading?: boolean;
};

export const ProviderForm = ({isLoading = false}: Props) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.setAttribute('allow', 'payment *');
    }
  }, []);

  return (
    <div className="relative w-full">
      {isLoading && <PaymentFormSkeleton />}
      <iframe
        ref={iframeRef}
        id="global-payment-iframe"
        title="Global Payments"
        allow="payment *"
        className="h-[562px] w-full border-none"
      />
    </div>
  );
};
